import React from "react";
import {Container, Link, Logo} from "./Header.css";
import logo from '/assets/brand.png?url';
import {useNavigate} from "react-router";
import {HideOnMobile} from "../../global.css";

function Header() {

    const navigate = useNavigate()
    return (
        <div className={Container}>
            <img src={logo} className={Logo}  alt={"Logo"}/>
            <span className={HideOnMobile}>|</span>
            <span className={HideOnMobile}>API PORTAL</span>
            <button className={Link} onClick={() => navigate("/home")}>Nos produits</button>
            <button className={Link} onClick={() => navigate("/home/contact")}>Nous contacter</button>
        </div>
    );
}

export default Header;